// action
import {
    SAVE_QUICK_SUPPORT_QUESTION_ANSWER,
    SAVE_QUICK_SUPPORT_QUESTION_ANSWER_FAIL,
    SAVE_QUICK_SUPPORT_QUESTION_ANSWER_SUCCESS,
    SAVE_QUICK_SUPPORT_QUESTION_ANSWER_RESET
} from '../action/saveQuickSupportQuestionAnswerAction'
import { api_err_msg } from "../strings.json"

// initialState
const initialState = {
    apiState: "",
    data: {},
    message: ""
}

export default function (state = initialState, action) {
    switch (action.type) {
        case SAVE_QUICK_SUPPORT_QUESTION_ANSWER:
            return {
                ...state,
                apiState: "loading"
            }
        case SAVE_QUICK_SUPPORT_QUESTION_ANSWER_FAIL:
            return {
                ...state,
                apiState: "error",
                message: action.response && action.response.data && action.response.data.message || api_err_msg,
            }
        case SAVE_QUICK_SUPPORT_QUESTION_ANSWER_SUCCESS:
            return {
                ...state,
                apiState: "success",
                message: action.response.data.message,
            }
        case SAVE_QUICK_SUPPORT_QUESTION_ANSWER_RESET:
            return initialState
        default:
            return state
    }
}